import React from "react";
import { Form } from "react-bootstrap";
import CustomTable from "../../components/CustomTable";
import { userTableeaders } from "../../constants/TableConstants";
import PrimaryButton from "../../components/PrimaryButton";
import PaginationComponent from "../../components/PaginationComponent";
import useUserManagementViewController from "../../viewControllers/UserManagementViewControllers/UserManagementViewController";
import Loader from "../../components/Loader";
import i18n from "../../constants/Strings";

const UserManagement = () => {

  const {
    userData,
    currentPage,
    totalPages,
    handlePageChange,
    setToggleStatus,
    setShowModal,
    handleShow,
    handleClose,
    showModal,
    handleConfirm,
    goBack,
    navigate,
    clickedIndex,
    loading,
  } = useUserManagementViewController();

  const text = {
    pageHeading: i18n.t('userManagement.pageHeading'),
    backBtn: i18n.t('userManagement.backBtn'),
    createBtn: i18n.t('userManagement.createBtn'),
    noDataFound: i18n.t('userManagement.noDataFound'),
  }

  return (
    <>
      {loading ? <Loader /> : (
        <>
          <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
            <Form className="d-none d-sm-inline-block form-inline mr-auto ml-md-3 my-2 my-md-0 navbar-search">
              <div className="d-flex justify-space-between">
                <div className="input-group"></div>
                <div className="mapping-create-btn">
                  <PrimaryButton
                    text={text.createBtn}
                    className="login-btn"
                    onClick={() => navigate("/user-management-create")}
                  />
                </div>
              </div>
            </Form>
          </nav>
          <div className="container-fluid">
            <div className=" mb-4">
              <div className="card-header py-3">
                <h6 className="m-0 font-weight-bold txt-primary">
                  {text.pageHeading}
                </h6>
              </div>
              {userData.length > 0 ? (
                <>
                  <CustomTable
                    data={userData}
                    headers={userTableeaders}
                    viewlink={"/user-management-view"}
                    resetlink={"/user-management-reset-password"}
                    setToggleStatus={setToggleStatus}
                    setShowModal={setShowModal}
                    handleShow={handleShow}
                    handleClose={handleClose}
                    showModal={showModal}
                    handleConfirm={handleConfirm}
                    clickedIndex={clickedIndex}
                  />

                  <PaginationComponent
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={handlePageChange}
                    data={userData?.length}
                  />
                </>
              ) : (
                <div className="text-center">{text.noDataFound}</div>
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default UserManagement;
